// extracted by mini-css-extract-plugin
module.exports = {"CatalogButtonScrolled":"catalog_CatalogButtonScrolled__sAAnQ","CatalogButton":"catalog_CatalogButton__QUGhG"};